<h4 class="module-title" i18n>Personal Information</h4>
@if (customerAllData) {
<form [formGroup]="customerAllData">
	<p-accordion [multiple]="true">
		<p-accordionTab i18n-header header="Personal Data" [selected]="true">
			<div>
				<!-- general grid -->
				<div class="p-fluid grid">
					<!-- left column -->
					<div class="field col-12 md:col-6 lg:col-4">
						<div class="p-float-label field">
							<br-image formControlName="avatar" mode="edit" subType="doctor_avatar"
								[style]="{'width':'100px', 'height':'100px'}"></br-image>
							<label i18n for="avatar">Avatar</label>
						</div>
						<div class="p-float-label field">
							<input id="name" type="text" formControlName="firstName" pInputText />
							<label class="required" for="name">
								<ng-container i18n>First name</ng-container>
								@if (customerAllData.controls.firstName.invalid &&
								customerAllData.controls.firstName.touched) {
									<ng-container i18n> is required!</ng-container>
								}
							</label>
						</div>
						<div class="p-float-label field">
							<input id="lastName" type="text" formControlName="lastName" pInputText />
							<label class="required" for="lastName">
								<ng-container i18n>Last name</ng-container>
								@if (customerAllData.controls.lastName.invalid &&
								customerAllData.controls.lastName.touched) {
									<ng-container i18n> is required!</ng-container>
								}
							</label>
						</div>
						<div class="p-float-label field">
							<p-dropdown floatLabelFix id="specialty" [autoDisplayFirst]="false"
								[style]="{'width':'100%' }" [showClear]="true" [options]="specialities"
								formControlName="specialty">
							</p-dropdown>
							<label class="required" for="specialty">
								<ng-container i18n>Speciality</ng-container>
								@if (customerAllData.controls.specialty.invalid &&
								customerAllData.controls.specialty.touched) {
									<ng-container i18n> is required!</ng-container>
								}
							</label>
						</div>
						<div class="p-float-label field">
							<input pInputText type="email" id="email" formControlName="email"
								email="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
							<label for="email">
								<ng-container i18n>E-mail</ng-container>
								@if (customerAllData.controls.email.invalid) {
									<ng-container i18n> is invalid!</ng-container>
								}
							</label>
						</div>
						<div class="p-float-label field">
							<input id="phone" type="text" formControlName="phone" pInputText />
							<label i18n for="phone">Phone</label>
						</div>
						<div class="p-float-label field">
							<input id="mobile" type="text" formControlName="mobile" pInputText />
							<label i18n for="mobile">Mobile phone</label>
						</div>
						<div class="p-float-label field">
							<input id="fax" type="text" formControlName="fax" pInputText />
							<label i18n for="fax">Fax</label>
						</div>
					</div>
					<!-- middle column -->
					<div class="col-12 lg:col-4 lg:mt-5">
						<br-address formControlName="address" [required]="true"></br-address>
					</div>
					<!-- right column -->
					<div class="field col-12 md:col-6 lg:col-4">
						<div class="p-float-label field">
							<input id="secretaryName" type="text" formControlName="secretaryName" pInputText />
							<label i18n for="secretaryName">Secretary name</label>
						</div>
						<div class="p-float-label field">
							<input id="secretaryPhone" type="text" formControlName="secretaryPhone" pInputText />
							<label i18n for="secretaryPhone">Secretary phone</label>
						</div>
						<div class="md:mt-5">
							<p-panel i18n-header header="Business Hours (start time - end time)">
								<table class="col-12">
									<tr>
										<td><label i18n>Monday</label></td>
									</tr>
									<tr>
										<td>
											<p-calendar formControlName="start1" [timeOnly]="true"
												dataType="string"></p-calendar>
										</td>
										<td>
											<p-calendar formControlName="end1" [timeOnly]="true"
												dataType="string"></p-calendar>
										</td>
									<tr style=margin-top:10px;>
										<td><label i18n>Tuesday</label></td>
									</tr>
									<tr>
										<td>
											<p-calendar formControlName="start2" [timeOnly]="true"
												dataType="string"></p-calendar>
										</td>
										<td>
											<p-calendar formControlName="end2" [timeOnly]="true"
												dataType="string"></p-calendar>
										</td>
									</tr>
									<tr style=margin-top:10px;>
										<td><label i18n>Wednesday</label></td>
									</tr>
									<tr>
										<td>
											<p-calendar formControlName="start3" [timeOnly]="true"
												dataType="string"></p-calendar>
										</td>
										<td>
											<p-calendar formControlName="end3" [timeOnly]="true"
												dataType="string"></p-calendar>
										</td>
									</tr>
									<tr>
										<td><label i18n>Thursday</label></td>
									</tr>
									<tr>
										<td>
											<p-calendar formControlName="start4" [timeOnly]="true" dataType="string"
												appendTo="body"></p-calendar>
										</td>
										<td>
											<p-calendar formControlName="end4" [timeOnly]="true" dataType="string"
												appendTo="body"></p-calendar>
										</td>
									</tr>
									<tr>
										<td><label i18n>Friday</label></td>
									</tr>
									<tr>
										<td>
											<p-calendar formControlName="start5" [timeOnly]="true" dataType="string"
												appendTo="body"></p-calendar>
										</td>
										<td>
											<p-calendar formControlName="end5" [timeOnly]="true" dataType="string"
												appendTo="body"></p-calendar>
										</td>
									</tr>
								</table>
							</p-panel>
						</div>
					</div>
				</div>
			</div>
		</p-accordionTab>
		<p-accordionTab i18n-header header="Service preferences">
			<div>
				<!-- general grid -->
				<div class="p-fluid">
					<!-- first row -->
					<div class="field grid">
						<div class="grid align-items-center m-1 col-12 md:m-0 md:col-4">
							<p-inputSwitch formControlName="notificationsEnabled"></p-inputSwitch>
							<label class="box ml-3" i18n>Notifications</label>
						</div>
						<div class="grid align-items-center m-1 col-12 md:m-0 md:col-4">
							<p-inputSwitch formControlName="statisticsEnabled"></p-inputSwitch>
							<label class="box ml-3" i18n>Statistic</label>
						</div>
						<div class="grid align-items-center m-1 col-12 md:m-0 md:col-4">
							<p-inputSwitch formControlName="recommendationsEnabled"></p-inputSwitch>
							<label class="box ml-3" i18n>Recommendations</label>
						</div>
						`
					</div>
					<!-- second row -->
					<div class="field grid">
						<div class="col-12 lg:col-4 md:col-4 sm:col-12">
							<p-panel i18n-header header="Exam Delivery Method">
								<p-dropdown placeholder="Please, select..." appendTo="body" [showClear]="true"
									[options]="examsDeliveryMethod" formControlName="examsDeliveryMethod"></p-dropdown>
								<div class="p-float-label">
									<textarea floatLabelFix pInputTextarea rows="2" cols="50" class="col-12"
										id="examsDeliveryMethodComment"
										formControlName="examsDeliveryMethodComment"></textarea>
									<label i18n for="examsDeliveryMethodComment">Notes</label>
								</div>
							</p-panel>
						</div>
						<div class="col-12 lg:col-4 md:col-4 sm:col-12">
							<p-panel i18n-header header="Result Delivery Method">
								<p-dropdown placeholder="Please, select..." appendTo="body" [showClear]="true"
									[options]="resultsDeliveryMethod"
									formControlName="resultsDeliveryMethod"></p-dropdown>
								<span class="p-float-label">
									<textarea floatLabelFix pInputTextarea rows="2" cols="50" class="col-12"
										id="resultsDeliveryMethodComment"
										formControlName="resultsDeliveryMethodComment"></textarea>
									<label i18n for="resultsDeliveryMethodComment">Notes</label>
								</span>
							</p-panel>
						</div>
						<div class="col-12 lg:col-4 md:col-4 sm:col-12">
							<p-panel i18n-header header="Payment Method">
								<p-dropdown placeholder="Please, select..." appendTo="body" [showClear]="true"
									[options]="paymentMethods" formControlName="paymentMethod"></p-dropdown>
								<span class="p-float-label">
									<textarea floatLabelFix pInputTextarea rows="2" cols="50" class="col-12"
										id="paymentMethodComment" formControlName="paymentMethodComment"></textarea>
									<label i18n for="paymentMethodComment">Notes</label>
								</span>
							</p-panel>
						</div>
					</div>
				</div>
			</div>
		</p-accordionTab>
		<p-accordionTab i18n-header header="Financial data">
			<div class="p-fluid grid">
				<div class="field col-12 md:col-6">
					<div class="p-float-label field">
						<input id="invoiceName" type="text" formControlName="invoiceName" pInputText />
						<label i18n for="invoiceName">Invoice name</label>
					</div>
					<div class="p-float-label field">
						<input id="invoiceAddress" type="text" formControlName="invoiceAddress" pInputText />
						<label i18n for="invoiceAddress">Invoice address</label>
					</div>
				</div>
				<div class="field col-12 md:col-6">
					<div class="p-float-label field">
						<input id="vatNumber" type="text" formControlName="vatNumber" pInputText />
						<label i18n for="vatNumber">VAT number</label>
					</div>
					<div class="p-float-label field">
						<input id="taxOffice" type="text" formControlName="taxOffice" pInputText />
						<label i18n for="taxOffice">Tax office</label>
					</div>
				</div>
			</div>
		</p-accordionTab>
	</p-accordion>
	<div class="mt-4 flex justify-content-end">
		<button pButton pRipple [disabled]="!isFormTouched()" type="button" i18n-label label="Cancel"
			icon="mdi mdi-close" class="p-button-outlined p-button-secondary" (click)="confirmDiscard()"></button>
		<button pButton pRipple [disabled]="!isFormTouched()" type="button" i18n-label label="Save" icon="mdi mdi-check"
			class="ml-2" (click)="confirmSaving()"></button>
	</div>
</form>
}
<br-image-upload></br-image-upload>
